/**
 * PC新首页，除导航外的入口
 * @author yongsheng.zhang
 */
// require('babel-polyfill');//新页头app-pc-index-header中有
require('./assets/styles/index.less')
const $ = require('jquery')
require('../../lib/servlet')
const myInfo = require('./component/my-info.js')
const picSwipe = require('./component/pic-nav.js')
const ad = require('./component/ad.js')
const CataNav = require('./component/cata-nav.js')
const sceneInit = require('./component/scene.js')
const LazyLoad = require('../../lib/lazyload.js')
const LXBid = require('../../lib/lx-bid.js')
const LXWrap = require('../../lib/lx.js')
const hotCataLx = require('./component/hot-cata.js')
const cityLocation = require('./component/city-location.js')
let timeing = window.performance ? window.performance.timing.navigationStart : _start
// 楼层导航
CataNav()

$(document).ready(options => {
    // 加载用户信息
    myInfo();
    // 图片轮播
    picSwipe('#pic-nav', '#pic-nav-ul', '.pic-item', true);
    // 加载景点信息
    sceneInit();
    var lazyload = new LazyLoad({
        item: $('#cata-detail img'), // 需要被懒加载的图片
        attr: 'lazy-src'
    });
    // 猫头鹰上报
    try {
        Owl.addPoint({
            position: 1,
            duration: +new Date() - timeing
        })
        Owl.sendPoints();
    } catch (e) {
        console.log('owl addpoint frist error');
    }
    // 模块中纯图片内容点击打点（商户图片，全部）
    LXWrap($('.cata-pic .pure-pic'), LXBid.picClickBid, true, false)
    LXWrap($('.cata-pic .view-more'), LXBid.picClickBid, true, false)

    // 模块中非纯图片内容点击打点(商户图片，标题，全部)
    LXWrap($('.cata-poi .view-more'), LXBid.poiClickBid, true, false)
    LXWrap($('.cata-poi .shop-item-pic'), LXBid.poiClickBid, true, false)
    LXWrap($('.cata-poi .shop-name'), LXBid.poiClickBid, true, false)

    // 模块推荐标签
    LXWrap($('.cata-tag a'), LXBid.tagClickBid, true, false)

    // 热门分类打点
    hotCataLx()

    // 图片hover
    $('#cata-detail').find('.shop-item-pic').on('mouseover', function(e) {
        $(this).find('.pic-overlay').show();
    });
    $('#cata-detail').find('.shop-item-pic').on('mouseleave', function(e) {
        $(this).find('.pic-overlay').hide();
    });
    ad()
    cityLocation()
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js